var _style, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYoutubeCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 29,
    x: 0,
    y: 0,
    viewBox: "0 0 29 29",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#fff}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M27.9 8.9C24.7 1.5 16.2-2 8.9 1.1 3.5 3.4 0 8.7 0 14.5 0 22.5 6.5 29 14.5 29c1.9 0 3.9-.4 5.6-1.1 7.4-3.2 10.9-11.7 7.8-19zm-3.4 6.4c0 1.6-.2 3.2-.2 3.2s-.2 1.4-.8 2c-.8.8-1.6.8-2 .8-2.8.2-7 .2-7 .2s-5.2 0-6.8-.2c-.4-.1-1.4-.1-2.2-.9-.6-.6-.8-2-.8-2s-.2-1.6-.2-3.2v-1.5c0-1.6.2-3.2.2-3.2s.2-1.4.8-2c.8-.8 1.6-.8 2-.8 2.8-.2 7-.2 7-.2s4.2 0 7 .2c.4 0 1.2 0 2 .8.6.6.8 2 .8 2s.2 1.6.2 3.2v1.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.4 17.1l5.4-2.8-5.4-2.8z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeCircle);
export default __webpack_public_path__ + "static/media/youtube-circle.4e7cdb1152d8fbb71ca61559692cf754.svg";
export { ForwardRef as ReactComponent };